export default "__VITE_ASSET__BIPNfp9T__"